var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:'btn-facebook' + _vm.componentKey,staticClass:"btn-facebook"},[_c('div',{staticClass:"fb-like",attrs:{"data-href":"https://www.facebook.com/pocketcurator/","data-width":"","data-layout":"button","data-action":"like","data-size":"small","data-show-faces":"true","data-share":"false"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73727324","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/BtnFacebook.vue
// module id = null
// module chunks = 